import { Button } from "@/components/button";
import { Flex } from "@/components/flex";
import { Form, FormItem, FormRow } from "@/components/form";
import { Icon } from "@/components/icon";
import { IBibliography } from "@/models/catalog.model";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { validationSchema } from "src/utils/validation-utils";

type Props = {
  bibliography: IBibliography;
  index: number;
  onBibliographySave: (bibliography: IBibliography, index: number) => void;
  onBibliographyDelete: (id: string) => void;
};

export const BibliographyCard = (props: Props) => {
  const { bibliography, index, onBibliographySave, onBibliographyDelete } = props;
  const [isEdit, setIsEdit] = useState<boolean>(!bibliography.content ? true : false);

  const defaultBibliography = {
    id: bibliography.id,
    content: "",
  };

  const {
    register,
    handleSubmit,
    getValues,
    reset,
    formState: { isValid },
  } = useForm({ mode: "onChange", defaultValues: defaultBibliography });

  const onSave = (data) => {
    onBibliographySave(data, index);
    setIsEdit(false);
  };

  const onCancel = () => {
    if (!getValues("content")) {
      onBibliographyDelete(getValues("id"));
    } else {
      setIsEdit(false);
    }
  };

  const onEdit = () => {
    reset(bibliography);
    setIsEdit(true);
  };

  return (
    <div className="NoteCard">
      {isEdit && (
        <Form>
          <FormRow>
            <FormItem>
              <textarea
                id="post_title"
                className="textarea"
                placeholder={"Inserisci bibliografia"}
                {...register("content", validationSchema.required)}
                defaultValue={getValues("content")}
              />
            </FormItem>
          </FormRow>

          <FormRow>
            <FormItem>
              <Flex container alignItems="center">
                <Button size="md" onClick={onCancel}>
                  {"Annulla"}
                </Button>

                <Button
                  className="ml-auto"
                  size="md"
                  color="primary"
                  disabled={!isValid}
                  onClick={handleSubmit(onSave)}
                >
                  {"Salva"}
                </Button>
              </Flex>
            </FormItem>
          </FormRow>
        </Form>
      )}

      {!isEdit && (
        <Flex container>
          {bibliography.content}

          <div className="button-group ml-auto">
            <Button onClick={onEdit}>
              <Icon content="edit" />
            </Button>
            <Button onClick={() => onBibliographyDelete(getValues("id"))}>
              <Icon content="bin" />
            </Button>
          </div>
        </Flex>
      )}
    </div>
  );
};
